export default "__VITE_ASSET__bd4a1526__"